import React from 'react';
import { Button } from '../../globalStyles';
import { AiFillThunderbolt } from 'react-icons/ai';
import { GiCrystalBars } from 'react-icons/gi';
import { GiCutDiamond, GiRock } from 'react-icons/gi';
import { GiFloatingCrystal } from 'react-icons/gi';
import { IconContext } from 'react-icons/lib';
import {
  PricingSection,
  PricingWrapper,
  PricingHeading,
  PricingContainer,
  PricingCard,
  PricingCardInfo,
  PricingCardIcon,
  PricingCardPlan,
  PricingCardCost,
  PricingCardLength,
  PricingCardFeatures,
  PricingCardFeature
} from './Pricing.elements';

function Pricing() {
  return (
    <IconContext.Provider value={{ color: '#a9b3c1', size: 64 }}>
      <PricingSection id='our-services'>
        <PricingWrapper>
          <PricingHeading>Nuestros servicios</PricingHeading>
          <PricingContainer>
            <PricingCard>
              <PricingCardInfo>
                <PricingCardIcon>
                  <GiRock />
                </PricingCardIcon>
                <PricingCardPlan>Sitio web Front-End</PricingCardPlan>
                <PricingCardFeatures>
                  <PricingCardFeature>Sitio web personal</PricingCardFeature>
                  <PricingCardFeature>Servicio de hosting</PricingCardFeature>
                  <PricingCardFeature>Dominio propio</PricingCardFeature>
                  <PricingCardFeature>SSL</PricingCardFeature>
                  <PricingCardFeature>Diseño responsivo</PricingCardFeature>
                  <PricingCardFeature>Herramientas de analisis de trafico</PricingCardFeature>
                  <PricingCardFeature>Soporte limitado</PricingCardFeature>
                  <PricingCardFeature>Formulario de contacto</PricingCardFeature>
                  <PricingCardFeature>Sistema de subscripciones</PricingCardFeature>
                </PricingCardFeatures>

              </PricingCardInfo>
            </PricingCard>
            <PricingCard>
              <PricingCardInfo>
                <PricingCardIcon>
                  <GiCrystalBars />
                </PricingCardIcon>
                <PricingCardPlan>Sitio web Full Stack</PricingCardPlan>

                <PricingCardFeatures>
                  <PricingCardFeature>Sitio web empresarial</PricingCardFeature>
                  <PricingCardFeature>Servicio de hosting</PricingCardFeature>
                  <PricingCardFeature>Dominio propio</PricingCardFeature>
                  <PricingCardFeature>SSL</PricingCardFeature>
                  <PricingCardFeature>Diseño responsivo</PricingCardFeature>
                  <PricingCardFeature>Herramientas de analisis de trafico</PricingCardFeature>
                  <PricingCardFeature>Base de datos en la nube</PricingCardFeature>
                  <PricingCardFeature>Sistema de pagos en la web</PricingCardFeature>
                  <PricingCardFeature>Soporte extendido</PricingCardFeature>
                </PricingCardFeatures>

              </PricingCardInfo>
            </PricingCard>
            <PricingCard>
              <PricingCardInfo>
                <PricingCardIcon>
                  <GiCutDiamond />
                </PricingCardIcon>
                <PricingCardPlan>App movil</PricingCardPlan>
                <PricingCardFeatures>
                  <PricingCardFeature>Aplicacion Android/iOS</PricingCardFeature>
                  <PricingCardFeature>Disponible en AppStore</PricingCardFeature>
                  <PricingCardFeature>Codigo Nativo</PricingCardFeature>
                  <PricingCardFeature>Soporte multiplataforma</PricingCardFeature>
                  <PricingCardFeature>Diseño a medida</PricingCardFeature>
                  <PricingCardFeature>Herramientas de analisis de trafico</PricingCardFeature>
                  <PricingCardFeature>Base de datos en la nube</PricingCardFeature>
                  <PricingCardFeature>Sistema de pagos movil</PricingCardFeature>
                  <PricingCardFeature>Soporte especifico</PricingCardFeature>
                </PricingCardFeatures>

              </PricingCardInfo>
            </PricingCard>
          </PricingContainer>
        </PricingWrapper>
      </PricingSection>
    </IconContext.Provider>
  );
}
export default Pricing;
